import { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { login } from "@/services/Users/login";

interface User {
    id: number;
    username: string;
    role: string;
}

export const Login = () => {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    const onFinish = async (values: { username: string; password: string }) => {
        setLoading(true);
        try {
            // login servisi artık token ve role'ü localStorage'a kaydediyor
            const res = await login(values.username, values.password);

            if (res.success) {
                setUser(res.user!); // component sadece state'i güncelliyor
                messageApi.success("Giriş başarılı!");
            } else {
                messageApi.error(res.message || "Giriş başarısız!");
            }
        } catch {
            messageApi.error("Giriş sırasında bir hata oluştu");
        } finally {
            setLoading(false);
        }
    };

    if (user) {
        return (
            <div>
                {contextHolder}
                <h2>Hoşgeldiniz {user.username}</h2>
                <p>Role: {user.role}</p>
            </div>
        );
    }

    return (
        <div style={{ width: 300 }}>
            {contextHolder}
            <Form
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off"
            >
                <Form.Item
                    label="Kullanıcı Adı"
                    name="username"
                    rules={[{ required: true, message: "Kullanıcı adı gerekli!" }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Şifre"
                    name="password"
                    rules={[{ required: true, message: "Şifre gerekli!" }]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading} block>
                        Giriş Yap
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};
